import type Firebase from './firebase';

let firebasePromise: Promise<typeof Firebase> | null = null;

export const getFirebase = () => {
    if (!firebasePromise) {
        firebasePromise = import('./firebase').then((module) => module.default);
    }
    return firebasePromise;
};
